module.exports = __webpack_public_path__ + "assets/img/contact.8b8d1000.svg";